<template>
  <v-autocomplete
    v-model="filterDepartment"
    :items="departments"
    label="Fachschaft suchen"
    item-text="description"
    return-object
    clearable
    v-bind="$attrs"
  >
    <template v-slot:item="data">
      <v-list-item-content>
        <v-list-item-title>{{ data.item.description }}</v-list-item-title>
      </v-list-item-content>
      <v-chip small>{{ data.item.count }}</v-chip>
    </template>
  </v-autocomplete>
</template>
<script>
import { defineComponent } from "vue";
export default defineComponent({
  name: "DepartmentFilter",
  props: {
    value: [],
  },
  data() {
    return {
      filterDepartment: [0],
      departments: [],
    };
  },
  watch: {
    filterDepartment(newValue) {
      window.localStorage.setItem("filterDepartment", JSON.stringify(newValue));
      this.$emit("input", newValue);
    },
    value() {
      this.filterDepartment = this.value;
    },
  },
  async mounted() {
    this.loading = true;
    this.departments = await this.apiList({ resource: "person/department" });
    if (localStorage.getItem("filterDepartment")) {
      this.filterDepartment = JSON.parse(
        localStorage.getItem("filterDepartment")
      );
    }
    this.loading = false;
  },
});
</script>
